
export function RenderCellTelphone(cellData:any){
  return (<a href={`tel:${cellData.value}`} className="dx-link">
    {cellData.value}
</a>)
}